<template>
    <v-modal-validated title="Añadir un nuevo estado"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       id="add-statuses-modal"
                       size="md"
                       @closed="closeModal"
                       @accepted="addStatus">

        <div class="form-group">
            <label class="form-label">Estado: </label>
            <Field type="text" name="status_name" class="form-control" aria-label="type" v-model="status.name">
                <select class="form-select" aria-label="Entidad" v-model="status.name">
                    <option v-for="status_name in statuses_names" :value="status_name.key">{{
                            status_name.value
                        }}
                    </option>
                </select>
            </Field>

            <ErrorMessage name="status_name"/>
        </div>

        <div class="form-group">
            <label>Observaciones:</label>
            <Field type="text" name="extra_data" class="form-control" aria-label="extra_data" v-model="status.extra_data">
                <textarea class="form-control" name="extra_data" v-model="status.extra_data"></textarea>
            </Field>

            <ErrorMessage name="extra_data"/>
        </div>

        <div class="form-group">
            <label>Fecha:</label>
            <div class="input-group">
                <Field type="datetime-local" name="date" class="form-control" v-model="status.date"/>
                <button class="delete-date" @click="status.date = ''" :disabled="!status.date ? true : null">
                    <span class="uq-icon bi-x-lg"></span>
                </button>
            </div>

            <ErrorMessage name="date"/>
        </div>
    </v-modal-validated>
</template>

<script>
import {getAvailableStatuses} from "../../../helpers/requests/RequestsAvailableStatuses";
import {createExpedientStatus, editExpedientStatus} from "../../../helpers/requests/RequestsStatuses";
import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";

export default {
    name: "StatusesListAddModal",
    components: {VModalValidated, Form, Field, ErrorMessage},
    props: ['expedientId'],
    data() {
        return {
            status: {},
            errors: [],
            modal: null,
            statuses_names: [],

            rules: {
                status_name: yup.string().required('Debes seleccionar un estado'),
                extra_data: yup.string(),
            }
        }
    },

    async mounted() {
        await this.loadAvailableStatuses();
        // TODO: This must be received from an API request that will send us the allowed statuses for our role
    },
    methods: {
        async loadAvailableStatuses() {
            this.statuses_names = await getAvailableStatuses();
        },
        async addStatus() {
            try {
                await createExpedientStatus(this.expedientId, this.status);

                this.$store.dispatch('app/setToastMessage', 'Estado añadido al expediente');
                this.$emit('expedient-status-added');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'No se ha podido añadir el estado al expediente');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
